/**
 * @license hugeicons-react v0.2.0
 *
 * See the LICENSE file in the root directory of this source tree.
 */

import r from"../create-hugeicon-component.js";const o=r("TextIndentMoreIcon",[["path",{d:"M15 4.5H20",stroke:"currentColor",key:"k0"}],["path",{d:"M15 9.5H18",stroke:"currentColor",key:"k1"}],["path",{d:"M15 14.5H20",stroke:"currentColor",key:"k2"}],["path",{d:"M15 19.5H18",stroke:"currentColor",key:"k3"}],["path",{d:"M11 3V21",stroke:"currentColor",key:"k4"}],["path",{d:"M4 8.5L5.54218 9.74227C6.84739 10.7937 7.5 11.3193 7.5 12C7.5 12.6807 6.84739 13.2063 5.54218 14.2577L4 15.5",stroke:"currentColor",key:"k5"}]]);export{o as default};
